import {
    GET_CONFIGURATION_LISTING,
    GET_CONFIGURATION_LISTING_SUCCESS,
    GET_CONFIGURATION_LISTING_FAIL,
    GET_CONFIGURATION_DETAILS,
    GET_CONFIGURATION_DETAILS_SUCCESS,
    GET_CONFIGURATION_DETAILS_FAIL,
    ADD_CONFIGURATION,
    ADD_CONFIGURATION_SUCCESS,
    ADD_CONFIGURATION_FAIL,
    UPDATE_CONFIGURATION,
    UPDATE_CONFIGURATION_SUCCESS,
    UPDATE_CONFIGURATION_FAIL,
    ADD_CONFIGURATION_ITEM,
    ADD_CONFIGURATION_ITEM_SUCCESS,
    ADD_CONFIGURATION_ITEM_FAIL,
    UPDATE_CONFIGURATION_ITEM,
    UPDATE_CONFIGURATION_ITEM_SUCCESS,
    UPDATE_CONFIGURATION_ITEM_FAIL,
    DELETE_CONFIGURATION,
    DELETE_CONFIGURATION_SUCCESS,
    DELETE_CONFIGURATION_FAIL,
    BULK_DELETE_CONFIGURATION,
    BULK_DELETE_CONFIGURATION_SUCCESS,
    BULK_DELETE_CONFIGURATION_FAIL,
    DELETE_CONFIGURATION_ITEM,
    DELETE_CONFIGURATION_ITEM_SUCCESS,
    DELETE_CONFIGURATION_ITEM_FAIL,
    BULK_DELETE_CONFIGURATION_ITEM,
    BULK_DELETE_CONFIGURATION_ITEM_SUCCESS,
    BULK_DELETE_CONFIGURATION_ITEM_FAIL,
    EXPORT_CONFIGURATION,
    EXPORT_CONFIGURATION_SUCCESS,
    EXPORT_CONFIGURATION_FAIL,
    RESET_CONFIGURATION_STATE,
} from "./actionTypes";

export const getConfigurationListing = configuration => ({
    type: GET_CONFIGURATION_LISTING,
    payload: configuration,
});

export const getConfigurationListingSuccess = configuration => ({
    type: GET_CONFIGURATION_LISTING_SUCCESS,
    payload: configuration,
});

export const getConfigurationListingFail = error => ({
    type: GET_CONFIGURATION_LISTING_FAIL,
    payload: error,
});

export const getConfigurationDetails = configurationId => ({
    type: GET_CONFIGURATION_DETAILS,
    payload: configurationId,
});

export const getConfigurationDetailsSuccess = configuration => ({
    type: GET_CONFIGURATION_DETAILS_SUCCESS,
    payload: configuration,
});

export const getConfigurationDetailsFail = error => ({
    type: GET_CONFIGURATION_DETAILS_FAIL,
    payload: error,
});

export const createConfigurationItem = configuration => ({
    type: ADD_CONFIGURATION_ITEM,
    payload: configuration,
});

export const createConfigurationItemSuccess = configuration => ({
    type: ADD_CONFIGURATION_ITEM_SUCCESS,
    payload: configuration,
});

export const createConfigurationItemFail = error => ({
    type: ADD_CONFIGURATION_ITEM_FAIL,
    payload: error,
});

export const updateConfigurationItem = configuration => ({
    type: UPDATE_CONFIGURATION_ITEM,
    payload: configuration,
});

export const updateConfigurationItemSuccess = configuration => ({
    type: UPDATE_CONFIGURATION_ITEM_SUCCESS,
    payload: configuration,
});

export const updateConfigurationItemFail = error => ({
    type: UPDATE_CONFIGURATION_ITEM_FAIL,
    payload: error,
});

export const createConfiguration = configuration => ({
    type: ADD_CONFIGURATION,
    payload: configuration,
});

export const createConfigurationSuccess = configuration => ({
    type: ADD_CONFIGURATION_SUCCESS,
    payload: configuration,
});

export const createConfigurationFail = error => ({
    type: ADD_CONFIGURATION_FAIL,
    payload: error,
});

export const updateConfiguration = configuration => ({
    type: UPDATE_CONFIGURATION,
    payload: configuration,
});

export const updateConfigurationSuccess = configuration => ({
    type: UPDATE_CONFIGURATION_SUCCESS,
    payload: configuration,
});

export const updateConfigurationFail = error => ({
    type: UPDATE_CONFIGURATION_FAIL,
    payload: error,
});

export const deleteConfiguration = configurationId => ({
    type: DELETE_CONFIGURATION,
    payload: configurationId,
});

export const deleteConfigurationSuccess = configurationId => ({
    type: DELETE_CONFIGURATION_SUCCESS,
    payload: configurationId,
});

export const deleteConfigurationFail = error => ({
    type: DELETE_CONFIGURATION_FAIL,
    payload: error,
});

export const bulkDeleteConfiguration = configurationId => ({
    type: BULK_DELETE_CONFIGURATION,
    payload: configurationId,
});

export const bulkDeleteConfigurationSuccess = configurationId => ({
    type: BULK_DELETE_CONFIGURATION_SUCCESS,
    payload: configurationId,
});

export const bulkDeleteConfigurationFail = error => ({
    type: BULK_DELETE_CONFIGURATION_FAIL,
    payload: error,
});

export const deleteConfigurationItem = configurationId => ({
    type: DELETE_CONFIGURATION_ITEM,
    payload: configurationId,
});

export const deleteConfigurationItemSuccess = configurationId => ({
    type: DELETE_CONFIGURATION_ITEM_SUCCESS,
    payload: configurationId,
});

export const deleteConfigurationItemFail = error => ({
    type: DELETE_CONFIGURATION_ITEM_FAIL,
    payload: error,
});

export const bulkDeleteConfigurationItem = configurationId => ({
    type: BULK_DELETE_CONFIGURATION_ITEM,
    payload: configurationId,
});

export const bulkDeleteConfigurationItemSuccess = configurationId => ({
    type: BULK_DELETE_CONFIGURATION_ITEM_SUCCESS,
    payload: configurationId,
});

export const bulkDeleteConfigurationItemFail = error => ({
    type: BULK_DELETE_CONFIGURATION_ITEM_FAIL,
    payload: error,
});

export const exportConfiguration = () => ({
    type: EXPORT_CONFIGURATION,
});

export const exportConfigurationSuccess = data => ({
    type: EXPORT_CONFIGURATION_SUCCESS,
    payload: data,
});

export const exportConfigurationFail = error => ({
    type: EXPORT_CONFIGURATION_FAIL,
    payload: error,
});

//reset
export const resetConfigurationState = () => {
    return {
        type: RESET_CONFIGURATION_STATE,
    }
}

